export class DataCatalogBiglakeProperties {
    'catalogId';
    'location';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "catalogId",
            "baseName": "catalogId",
            "type": "string",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogBiglakeProperties.attributeTypeMap;
    }
    constructor() {
    }
}
